import Main from "./Containers/Main/index.js"

function App() {
  return (
    <Main/>
  );
}

export default App;
